import { MedisanteDevice } from '../../../../pages/Device/types';
import { FunctionComponent, useState } from 'react';
import { useChangeMuteDeviceMutation } from '../../../../store/api-slice';
import { useConfig } from '../../../../eliot-components/src/ConfigProvider/hooks';
import ConfirmationDialog from '../../../../eliot-components/src/ConfirmationDialog/ConfirmationDialog';

interface Props {
  devices: MedisanteDevice[];
  isOpen: boolean;
  onClose?(): void;
  onUpdated(err?: string): void;
}

const MuteDevice: FunctionComponent<Props> = ({
  devices,
  isOpen,
  onClose,
  onUpdated,
}) => {
  const config = useConfig();
  const [muteDevice] = useChangeMuteDeviceMutation();
  const isMuted =
    devices &&
    devices.find(
      (d) => d.properties && d.properties.muted && d.properties.muted.length > 0
    );
  const [isLoading, setisLoading] = useState(false);
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onClose={onClose}
      noCloseOnConfirm={true}
      onConfirm={() => {
        setisLoading(true);
        muteDevice({
          devices: devices,
          mute: !isMuted,
          apiBaseURL: config.apiBaseURL,
          orgIDs: devices.map((d) => d.owner),
        })
          .then(() => {
            setisLoading(false);
            onUpdated();
          })
          .catch((err) => {
            setisLoading(false);
            onUpdated(err.message);
          });
      }}
      disabled={false}
      isLoading={isLoading}
      questionText={`Are you sure you want to ${isMuted ? 'unmute' : 'mute'}?`}
      confirmationText="Confirm"
      cancelText="Cancel"
      title={'Mute device'}
    />
  );
};

export default MuteDevice;
